import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import CompanyIcon from '../../Icons/CompanyIcon/CompanyIcon';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';
import CommonBox, { LeftRailButton } from '../CommonBox/CommonBox';

import './CompaniesBox.scss';

const companiesClickMetric = {
    misc_event_count: 1,
    misc_event_type: 'left-rail-companies-click',
};
const svg = <CompanyIcon />;
const loggedOutDescription = 'Get alerted when there are new employee reviews.';

class CompaniesBox extends React.PureComponent {
    renderDescription = (isLoggedIn) => {
        const { companyCount } = this.props;
        return isLoggedIn && companyCount ? null : loggedOutDescription;
    };

    renderLoggedInContent = () => {
        const { openModal } = this.props;
        const companies = this.props.companies.slice(0, 5);
        const { companyCount } = this.props;
        const primaryButtonText = companyCount ? 'Manage' : 'Explore';

        return (
            <React.Fragment>
                <div className="companies">
                    {companies.map((company) => (
                        <a
                            key={company.companyUrl}
                            className="company"
                            href={company.companyUrl}
                        >
                            {company.companyName}
                        </a>
                    ))}
                </div>
                <LeftRailButton
                    text={primaryButtonText}
                    onClick={openModal}
                    metric={companiesClickMetric}
                />
            </React.Fragment>
        );
    };

    renderLoggedOutContent = (pageContext) =>
        pageContext.wrapAuth(
            'leftrail-companies',
            LeftRailButton({ text: 'Explore' }),
            { login_trigger: 'leftrail-companies' },
            null,
            LOGIN_LAYOUT
        );

    render() {
        const count = this.props.companyCount
            ? `(${this.props.companyCount})`
            : '';
        return (
            <PageConsumer>
                {(pageContext) => {
                    const title = pageContext.isLoggedIn()
                        ? `COMPANIES YOU FOLLOW ${count}`
                        : `COMPANIES YOU FOLLOW`;
                    return (
                        <CommonBox
                            svg={svg}
                            title={title}
                            description={this.renderDescription(
                                pageContext.isLoggedIn()
                            )}
                        >
                            {pageContext.isLoggedIn()
                                ? this.renderLoggedInContent()
                                : this.renderLoggedOutContent(pageContext)}
                        </CommonBox>
                    );
                }}
            </PageConsumer>
        );
    }
}

CompaniesBox.propTypes = {
    /**
     * companies a user follows
     */
    companies: PropTypes.arrayOf(
        PropTypes.shape({
            companyId: PropTypes.number,
            companyName: PropTypes.string,
            companyUrl: PropTypes.string,
            // eslint-disable-next-line react/forbid-prop-types
            logo: PropTypes.object,
            rating: PropTypes.number,
            companyEndpoint: PropTypes.string,
        })
    ),
    /**
     * a total company count
     */
    companyCount: PropTypes.number,
    /**
     *  a function to open a companies-modal
     */
    openModal: PropTypes.func,
};

CompaniesBox.defaultProps = {
    companies: [],
    companyCount: 0,
    openModal: () => {},
};

export default CompaniesBox;
